import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { NgxMatMomentAdapter } from '@angular-material-components/moment-adapter';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter{
    override getFirstDayOfWeek(): number {
        return 1;
    }
}

export class NgxCustomDateAdapter extends NgxMatMomentAdapter{
    override getFirstDayOfWeek(): number {
        return 1;
    }
}